<div class="cb-select-wrapper" [cbPopover]="Dropdown" [popoverDisabled]="disabled() ?? false" [showArrow]="false"
  [matchParentWidth]="matchParentWidth()" (popoverOpen)="popoverOpened()" (popoverClose)="popoverClosed()"
  (popoverClose)="onTouchedCallback()" [popoverPosition]="'bottom'" [class.cb-disabled]="disabled()"
  [class.cb-required]="required()" [class.cb-error]="error()">
  @if (label() || info()) {
  <div class="cb-select-label">
    @if (label()) {
    <label>{{ label() }}</label>
    }
    @if (info() && info()!.length > 0) {
    <cb-icon [cbTooltip]="info()!" tooltipPosition="top" tooltipStyle="dark" name="cb-base-outline-help"></cb-icon>
    }
  </div>
  }
  <div class="cb-select-container">
    @if (leadingText()) {
    <div class="cb-select-leading-text">
      <p>{{ leadingText() }}</p>
    </div>
    }
    <div class="cb-select">
      @if (icon() || prefix()) {
      <div #Prefix class="cb-select-prefix">
        @if (icon()) {
        <cb-icon [name]="icon()!"></cb-icon>
        }
        @if (prefix()) {
        <p>{{ prefix() }}</p>
        }
      </div>
      }

      <div #Input class="cb-select-value" [class.cb-multiline]="multiline()"
        [attr.tabindex]="disabled() ? undefined : 0" (keydown.arrowdown)="onArrowDown($event)"
        (keydown.arrowup)="onArrowUp($event)" (keydown.enter)="onEnter($event)" (keydown.escape)="onEscape($event)">
        @if (innerValue().length > 0) {
        @if (shownValueTemplate()) {
        @for (v of innerValue(); track $index) {
        <div class="cb-select-value-template">
          <ng-container *ngTemplateOutlet="
                    shownValueTemplate()!;
                    context: { $implicit: v }
                  "></ng-container>
        </div>
        }
        } @else {
        @if (multiline()) {
        @for (v of innerValue(); track $index) {
        <span>{{
          translateOptions() ? (v.label | translate) : v.label
          }}</span>
        }
        } @else if (enableFreeText()) {
        @for (v of innerValue(); track $index) {
        <span class="pr-1">
          <cb-chip rounded="badge" color="gray" iconType="icon" icon="cb-base-outline-close" [label]="v.label"
            (click)="freeTextInputDelete($event, $index)"></cb-chip>
        </span>
        }
        } @else {
        <span>{{ strValue() }}</span>
        }
        }
        } @else if (!enableFreeText()) {
        <span class="cb-select-placeholder">{{ placeholder() }}</span>
        }

        @if (enableFreeText()) {
        <input [(ngModel)]="searchText" [placeholder]="innerValue().length > 0 ? '' : placeholder()"
          (click)="$event.stopImmediatePropagation()" (focus)="freeTextInputFocus($event)" (blur)="onTouchedCallback()"
          (input)="freeTextInput($event)" (keydown.enter)="freeTextInputEnter($event)"
          (keydown.backspace)="freeTextInputDelete($event)" (keydown.arrowdown)="freeTextInputDown($event)"
          (keydown.arrowup)="freeTextInputUp($event)" />
        }
      </div>

      <!-- @if(canReset()){
            <div class="cb-select-reset-button-container" (click)="reset(); $event.stopImmediatePropagation()">
                <div class="cb-select-reset-button">
                    <cb-icon name="cb-base-outline-close"></cb-icon>
                </div>
            </div>
            } -->

      <div #Suffix class="cb-select-suffix">
        @if (canReset()) {
        <div class="cb-select-reset-button-container" (click)="reset(); $event.stopImmediatePropagation()">
          <div class="cb-select-reset-button">
            <cb-icon name="cb-base-outline-close"></cb-icon>
          </div>
        </div>
        }
        @if (suffix()) {
        <p class="cb-select-suffix">{{ suffix() }}</p>
        }
        <cb-icon name="cb-base-outline-chevron-down"></cb-icon>
      </div>
    </div>
    @if (trailingText()) {
    <div class="cb-select-trailing-text">
      <p>{{ trailingText() }}</p>
    </div>
    }
  </div>
  @if (hint() && hint()!.length > 0) {
  <p class="cb-select-hint">{{ hint()! }}</p>
  }
</div>

<ng-template #Dropdown>
  <div #DropdownContainer class="cb-select-dropdown">
    @if (filter() && !enableFreeText()) {
    <div class="cb-select-dropdown-search">
      @if(searchType() === "string") {
      <cb-input [(ngModel)]="searchText" [autofocus]="true" icon="cb-base-outline-search"
        [placeholder]="'COMMON.SEARCH' | translate" (keydown.arrowdown)="onArrowDown($event)"
        (keydown.arrowup)="onArrowUp($event)" (keydown.enter)="onEnter($event)"
        (keydown.escape)="onEscape($event)"></cb-input>
      } @else if (searchType() === "number") {
      <cb-input-number [(ngModel)]="searchNumber" [autofocus]="true" icon="cb-base-outline-search"
        [placeholder]="'COMMON.SEARCH' | translate" (keydown.arrowdown)="onArrowDown($event)"
        (keydown.arrowup)="onArrowUp($event)" (keydown.enter)="onEnter($event)"
        (keydown.escape)="onEscape($event)"></cb-input-number>
      }
    </div>
    }

    @if (isLoading()) {
    <div class="cb-select-dropdown-loader">
      <cb-loader></cb-loader>
    </div>
    } @else {
    @if (showFreeTextInsert() && searchText() && searchText()!.length > 0) {
    <div class="cb-select-dropdown-option" (mousedown)="addFreeText()" [class.cb-focused]="focusedOptionIndex() === -1">
      <p>{{ "COMMON.ADD" | translate }}: {{ searchText() }}</p>
    </div>
    }

    @if (filteredGroupedOptions().length > 0) {
    <div class="cb-select-dropdown-groups">
      @for (group of filteredGroupedOptions(); track $index) {
      @let groupIndex = $index;
      <div class="cb-select-dropdown-group">
        @if (group.label) {
        <h6>
          {{
          translateGroupLabels()
          ? (group.label | translate)
          : group.label
          }}
        </h6>
        }
        <div class="cb-select-dropdown-options">
          @for (option of group.options; track $index) {
          @let optionIndex = $index;
          @let globalIndex =
          getGlobalOptionIndex(groupIndex, optionIndex);
          <ng-container *ngTemplateOutlet="
                      OptionTemplate;
                      context: {
                        $implicit: option,
                        isFocused: focusedOptionIndex() === globalIndex,
                        optionGlobalIndex: globalIndex,
                      }
                    "></ng-container>
          }
        </div>
      </div>
      }
    </div>
    } @else {
    @let len = filteredOptions().length || 0;
    @if (virtualScrollEnabled()) {
    <div class="cb-select-dropdown-options cb-virtual-scroll" [ngStyle]="{
              '--itemsHeight': optionsHeight(),
              '--itemsCount': len <= 5 ? len : 5,
            }">
      @if (len > 0) {
      <cdk-virtual-scroll-viewport #VirtualScrollViewport [itemSize]="optionsHeightNumber()">
        <ng-container *cdkVirtualFor="
                    let option of filteredOptions();
                    let i = index
                  ">
          <div class="cb-select-dropdown-option-wrapper">
            <ng-container *ngTemplateOutlet="
                        OptionTemplate;
                        context: {
                          $implicit: option,
                          isFocused: focusedOptionIndex() === i,
                          optionGlobalIndex: i,
                        }
                      "></ng-container>
          </div>
        </ng-container>
      </cdk-virtual-scroll-viewport>
      } @else {
      <p class="cb-select-empty">
        {{ "COMMON.NO_RESULTS_FOUND" | translate }}
      </p>
      }
    </div>
    } @else {
    <div class="cb-select-dropdown-options">
      @if (len > 0) {
      @for (option of filteredOptions(); track $index) {
      <div class="cb-select-dropdown-option-wrapper">
        <ng-container *ngTemplateOutlet="
                      OptionTemplate;
                      context: {
                        $implicit: option,
                        isFocused: focusedOptionIndex() === $index,
                        optionGlobalIndex: $index,
                      }
                    "></ng-container>
      </div>
      }
      } @else {
      <p class="cb-select-empty">
        {{ "COMMON.NO_RESULTS_FOUND" | translate }}
      </p>
      }
    </div>
    }
    }
    }
  </div>

  <ng-template #OptionTemplate let-option let-isFocused="isFocused" let-optionGlobalIndex="optionGlobalIndex">
    @let isSelected = selectedValues().includes(option.value);
    <div class="cb-select-dropdown-option" [class.cb-selected]="isSelected" [class.cb-focused]="isFocused"
      [class.cb-disabled]="option.isDisabled" [id]="'cb-select-option-' + (optionGlobalIndex ?? 0)"
      (click)="selectOption(option)">
      @if (shownOptionTemplate()) {
      @if (selectionMode() === "multiple") {
      <cb-checkbox size="sm" [selected]="isSelected"></cb-checkbox>
      }
      <div class="cb-select-dropdown-option-template">
        <ng-container *ngTemplateOutlet="
              shownOptionTemplate()!;
              context: { $implicit: option }
            "></ng-container>
      </div>
      @if (selectionMode() === "single" && isSelected) {
      <cb-icon name="cb-base-outline-check"></cb-icon>
      }
      } @else {
      @if (selectionMode() === "multiple") {
      <cb-checkbox size="sm" [selected]="isSelected" [label]="
              translateOptions() ? (option.label | translate) : option.label
            "></cb-checkbox>
      } @else {
      <p>
        {{ translateOptions() ? (option.label | translate) : option.label }}
      </p>
      @if (isSelected) {
      <cb-icon name="cb-base-outline-check"></cb-icon>
      }
      }
      }
    </div>
  </ng-template>
</ng-template>